// removed by extract-text-webpack-plugin
module.exports = {"notFoundComponent":"NotFound__notFoundComponent","background":"NotFound__background","content":"NotFound__content","title":"NotFound__title","subtitle":"NotFound__subtitle","reasons":"NotFound__reasons","logo":"NotFound__logo","growDotQello":"NotFound__growDotQello","growDotBlue":"NotFound__growDotBlue","growDotGolden":"NotFound__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFound/NotFound.scss
// module id = 1910
// module chunks = 0